import { render, staticRenderFns } from "./TextNotPermisionPrueba.vue?vue&type=template&id=1bf99a2d&scoped=true&"
import script from "./TextNotPermisionPrueba.vue?vue&type=script&lang=js&"
export * from "./TextNotPermisionPrueba.vue?vue&type=script&lang=js&"
import style0 from "./TextNotPermisionPrueba.vue?vue&type=style&index=0&id=1bf99a2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf99a2d",
  null
  
)

export default component.exports